import { useQuery } from '@tanstack/react-query';
import { api } from './api';

/**
 * "NE KADAR KENARA AYIRMALIYIM" — panel istemcisi.
 *
 * ⚠ HESAP SUNUCUDA. Burada hiçbir oran, dilim ya da eşik YOKTUR ve olmamalıdır:
 * ikinci bir kopya, endeksli tutarların değiştiği ilk Ocak'ta sessizce eski
 * rakamı göstermeye başlar. Panel yalnız GÖSTERİR ve ANLATIR.
 *
 * ⚠ TUTARLAR METİNDİR ve panel onlarla aritmetik YAPMAZ (`money.ts` doktrini).
 */

export interface TaxReserve {
  incomeYear: number;
  /** Beyanın verileceği yıl — gelir yılıyla karıştırılmamalı. */
  assessmentYear: number;
  asOf: string;

  socialStatus: 'BIJBEROEP' | 'HOOFDBEROEP';
  costMethod: 'ACTUAL' | 'FORFAIT';
  communalTaxPct: string;
  managementFeePct: string;

  counts: {
    salesInvoices: number;
    purchases: number;
    expenses: number;
    draftPurchases: number;
    draftExpenses: number;
  };

  /** Bu yıl aktifleştirilen yatırım maliyeti — GİDER DEĞİLDİR. */
  investmentCost: string;
  /** Duran varlık defterinden gelen, bu yılın indirilebilir amortismanı. */
  depreciation: string;
  depreciatingAssets: number;

  amounts: {
    revenue: string;
    actualCosts: string;
    appliedCosts: string;
    alternativeCosts: string;
    forfaitBreakEven: string;
    socialBase: string;
    socialContribution: string;
    managementFee: string;
    socialTotal: string;
    taxableProfessionalIncome: string;
    salariedIncome: string;
    incomeTaxIncrement: string;
    communalTax: string;
    totalReserve: string;
    profit: string;
    netAfterReserve: string;
  };

  marginalRatePct: string;
  reservePctOfProfit: string | null;
  warnings: string[];
}

export const taxReserveKey = (year: number | undefined) => ['reports', 'tax-reserve', year] as const;

export function useTaxReserve(year?: number) {
  return useQuery({
    queryKey: taxReserveKey(year),
    queryFn: () =>
      api.get<TaxReserve>(year === undefined ? '/reports/tax-reserve' : `/reports/tax-reserve?incomeYear=${String(year)}`),
  });
}

/**
 * Uyarı metinleri — her biri NE YAPILACAĞINI söyler.
 *
 * ⚠ "Bir şeyler eksik" diyen bir uyarı, uyarı değildir. Kullanıcı bu ekranda
 * para ayırma kararı veriyor; her satır rakamın hangi yönde saptığını ve
 * düzeltmek için nereye gidileceğini yazmak zorunda.
 */
export const TAX_RESERVE_WARNINGS: Record<string, string> = {
  SALARY_ESTIMATE_MISSING:
    'Maaşlı gelir tahmini girilmemiş. Serbest meslek kârı maaşın ÜSTÜNE bindiği için marjinal dilim onunla belirlenir; boşken rakam OLDUĞUNDAN DÜŞÜK çıkar. Ayarlar → Sosyal statü.',
  BELOW_SOCIAL_THRESHOLD:
    'Kâr, bijberoep muafiyet eşiğinin altında: bu yıl sosyal prim doğmuyor. Eşiği aştığınız anda prim TÜM gelire uygulanır, yalnız aşan kısma değil.',
  SOCIAL_THRESHOLD_CLIFF:
    'Kâr, muafiyet eşiğinin hemen çevresinde. Bu bir UÇURUMDUR: eşiğin bir euro üstünde prim sıfırdan yaklaşık 394 €’ya sıçrar. Yıl sonu faturalarının tarihini buna göre değerlendirin.',
  HOOFDBEROEP_MINIMUM_NOT_MODELLED:
    'Statü hoofdberoep. Asgari çeyreklik prim bu hesapta MODELLENMEDİ; gerçek yük burada görünenden yüksek olabilir. Sosyal kasanızın baremiyle doğrulayın.',
  FORFAIT_CAP_REACHED:
    'Gider forfaiti tavana dayandı: kâr artsa da indirilecek gider artmıyor. Gerçek gider yöntemi büyük olasılıkla daha avantajlı.',
  OTHER_COST_METHOD_BETTER:
    'Diğer gider yöntemi daha çok indirim verirdi. İki yöntem KARIŞTIRILAMAZ — yıl için biri seçilir. Ayarlar → Sosyal statü → Gider yöntemi.',
  DRAFT_PURCHASES_EXCLUDED:
    'Onaylanmamış alış faturaları hesaba KATILMADI. Onaylandıklarında gider artar ve ayrılacak tutar düşer.',
  DRAFT_EXPENSES_EXCLUDED:
    'Onaylanmamış fişler hesaba KATILMADI. Onaylandıklarında gider artar ve ayrılacak tutar düşer.',
  INVESTMENTS_NOT_REGISTERED:
    'Onaylanmış alışlarda duran varlık defterine ALINMAMIŞ yatırım (kutu 83) var. Deftere alınmadıkça amortismanı indirilmiyor — yani ayrılacak tutar olduğundan YÜKSEK görünüyor. Duran varlıklar ekranındaki "deftere alınmamış yatırımlar" listesinden ekleyin.',
  INCOME_TAX_RATES_UNVERIFIED:
    'Gider indirim oranları (restoran %69, temsil %50 …) depoda DOĞRULANMAMIŞ olarak işaretli bir tablodan geliyor. Rakam bu oranlara duyarlıdır; büyük kalemlerde oranı kendiniz teyit edin.',
};
